export const KEY_CODES = {
	ESCAPE: 27,
};

export const BREAKPOINT_VALUES = {
	MINIMUM: 320,
	MOBILESMALL: 375,
	MOBILELARGE: 425,
	XSMALL: 544,
	SMALL: 768,
	MEDIUM: 990,
	XMEDIUM: 1024,
	LARGE: 1200,
	XLARGE: 1440,
};

export const COLORS = {
	BRAND: '#7fba23',
	ACTION: '#0074cc',
	DEAL: '#d71664',
	ATTENTION: '#ff9500',
};
